module.exports = __webpack_public_path__ + "img/Fabella_round.b85b3c2c.png";